import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import {
  IFilterComponentProps,
  IFilterInstance,
} from "@mapmycustomers/shared/types/fieldModel/IFilterConfig";
import { NumberField, NumberFieldComponent } from "@mapmycustomers/ui";

import styles from "./DurationFilter.module.scss";
import { DurationFilterOptions, getDurationConverters } from "./durationUnit";

export const DURATION_FILTER_OPERATORS = [
  FilterOperator.EQUALS,
  FilterOperator.NOT_EQUAL,
  FilterOperator.GREATER_THAN,
  FilterOperator.GREATER_THAN_OR_EQUAL,
  FilterOperator.LESS_THAN,
  FilterOperator.LESS_THAN_OR_EQUAL,
];

interface DurationFilterProps extends IFilterComponentProps {}

export const getDurationFilter = (options: DurationFilterOptions = {}): IFilterInstance => {
  const { minutesToValue, valueToMinutes } = getDurationConverters(options.inSeconds ?? false);

  return {
    doesSupportValue: (value: any, operator: FilterOperator) => {
      return typeof value === "number" && DURATION_FILTER_OPERATORS.includes(operator);
    },
    getComponent:
      (): ((props: DurationFilterProps) => JSX.Element) =>
      ({ className, disabled, focus, onChange, placeholder, value }: DurationFilterProps) => {
        const intl = useIntl();
        const setRef = useCallback(
          (ref: null | NumberFieldComponent) => {
            if (focus && ref) {
              ref.focus();
            }
          },
          [focus]
        );
        return (
          <div className={styles.container}>
            <NumberField
              disabled={disabled}
              inputClassName={className}
              onChange={(number) => onChange?.({ ...value, value: minutesToValue(number) })}
              placeholder={placeholder as string}
              ref={setRef}
              size="middle"
              value={valueToMinutes(value?.value)}
            />
            <span className={styles.suffix}>
              {intl.formatMessage({
                id: "filters.duration.suffix",
                defaultMessage: "mins",
                description: "Mins suffix in duration field filter",
              })}
            </span>
          </div>
        );
      },
  };
};

export default getDurationFilter();
